import { render, staticRenderFns } from "./AddRegistryType.vue?vue&type=template&id=5487417f&"
import script from "./AddRegistryType.vue?vue&type=script&lang=js&"
export * from "./AddRegistryType.vue?vue&type=script&lang=js&"
import style0 from "./AddRegistryType.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports